var _defs, _path, _line, _line2, _line3, _circle, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayBrowserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        stroke-width: 1.2px;\n      }\n\n      .b, .c {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .c {\n        stroke-width: 1.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3,17.25h12c1.24,0,2.25-1.01,2.25-2.25V3c0-1.24-1.01-2.25-2.25-2.25H3C1.76.75.75,1.76.75,3v12c0,1.24,1.01,2.25,2.25,2.25Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.9,
    y1: 10.89,
    x2: 8.9,
    y2: 2.76
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.9,
    y1: 2.76,
    x2: 11.03,
    y2: 4.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.9,
    y1: 2.76,
    x2: 6.77,
    y2: 4.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8.9,
    cy: 14.03,
    r: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 12.79,
    cy: 7.47,
    r: 1.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 12.74,
    y1: 11.61,
    x2: 13.81,
    y2: 10.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 12.74,
    y1: 11.61,
    x2: 13.81,
    y2: 12.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 11.68,
    y1: 10.55,
    x2: 12.74,
    y2: 11.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 11.68,
    y1: 12.68,
    x2: 12.74,
    y2: 11.61
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.21,
    cy: 11.87,
    r: 1.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 5.26,
    y1: 7.73,
    x2: 4.19,
    y2: 8.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 5.26,
    y1: 7.73,
    x2: 4.19,
    y2: 6.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.32,
    y1: 8.79,
    x2: 5.26,
    y2: 7.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.32,
    y1: 6.66,
    x2: 5.26,
    y2: 7.73
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBrowserIcon);
export default __webpack_public_path__ + "static/media/play-browser-icon.2d94a917bedc868faa2b40d8cb9e85f6.svg";
export { ForwardRef as ReactComponent };